import { Paper } from "@material-ui/core";
import DonutChart from "src/components/ScoringChart/DonutChart";
import { TOP_COLOR_LIST } from "src/config/styleConfig";

export default function TokenRankDetailChart({ token, data }) {
  const getOption = () => ({
    colors: TOP_COLOR_LIST,
    title: {
      text: `${token} rank distribution`,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        innerSize: "90%",
      },
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    tooltip: {
      // eslint-disable-next-line quotes
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        // eslint-disable-next-line quotes
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b><br/><span>{point.yRaw:,.1f} {series.name}</span>',
      // pointFormat: '<span style="fill:{point.color}">●</span> <span>{point.name}</span>: <b>{point.y:.2f}%</b>',
      style: {
        fontSize: "14px",
      },
    },
  });
  const series = [
    {
      name: token,
      data: data.map((item, idx) => ({ name: `Rank ${idx + 1}`, y: item[0], yRaw: item[1] })),
    },
  ];
  return (
    <Paper>
      <DonutChart series={series} option={getOption()} />
    </Paper>
  );
}
